/**
 * The "height" CSS attribute.
 * @type {String}
 */
export const HEIGHT = 'height';

/**
 * The "width" CSS attribute.
 * @type {String}
 */
export const WIDTH = 'width';

/**
 * The "style" CSS attribute.
 * @type {String}
 */
export const STYLE = 'style';

/**
 * The list of SVG tags we're aware of.
 * @type {Object.<String, String>}
 */
const SVG_TAGS = {
    TITLE: 'title',
    DESC: 'desc',
    META: 'meta',
    STYLE: 'style',
    PATH: 'path',
    CIRCLE: 'circle',
    RECT: 'rect',
    LINE: 'line',
    ELLIPSE: 'ellipse',
    POLYGON: 'polygon',
    POLYLINE: 'polyline',
    GROUP: 'g',
    LINEAR_GRADIENT: 'linearGradient',
    RADIAL_GRADIENT: 'radialGradient',
    USE: 'use',
    TEXT: 'text',
};

/**
 * The grey list of SVG tags the editor's won't support naturally, but it won't cause any serious damaged behaviour
 * @type {String[]}
 */
export const GREYLISTED_SVG_TAGS = [SVG_TAGS.TITLE, SVG_TAGS.DESC, SVG_TAGS.META, SVG_TAGS.STYLE];

/**
 * The white list of allowed SVG tags the editor accepts.
 * @type {String[]}
 */
export const WHITELISTED_SVG_TAGS = [
    SVG_TAGS.PATH,
    SVG_TAGS.CIRCLE,
    SVG_TAGS.RECT,
    SVG_TAGS.LINE,
    SVG_TAGS.ELLIPSE,
    SVG_TAGS.POLYGON,
    SVG_TAGS.POLYLINE,
    SVG_TAGS.GROUP,
    SVG_TAGS.LINEAR_GRADIENT,
    SVG_TAGS.RADIAL_GRADIENT,
    SVG_TAGS.USE,
];

/**
 * The fill attribute can be applied to any element but it only has an effect on
 * the following elements
 * @link: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill
 */
export const FILLABLE_SVG_TAGS = [
    SVG_TAGS.PATH,
    SVG_TAGS.CIRCLE,
    SVG_TAGS.RECT,
    SVG_TAGS.ELLIPSE,
    SVG_TAGS.POLYGON,
    SVG_TAGS.POLYLINE,
    SVG_TAGS.TEXT,
];

/**
 * The list of SVG attributes
 * @type {String[]}
 */
export const SVG_ATTRIBUTES = {
    FILL: 'fill',
    STROKE: 'stroke',
    FILL_OPACITY: 'fillOpacity',
    STROKE_OPACITY: 'strokeOpacity',
    STROKE_WIDTH: 'strokeWidth',
};

export { SVG_TAGS };

export const UNITS = {
    PX: 'px',
    EM: 'em',
};
